import React from 'react';
import { TableHead } from './table';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';

export const SortableHeader = ({ label, sortKey, sortConfig, onSort, className = '' }) => {
  const isActive = sortConfig.key === sortKey;
  return (
    <TableHead
      className={`cursor-pointer select-none hover:bg-gray-100 transition-colors ${className}`}
      onClick={() => onSort(sortKey)}
      data-testid={`sort-${sortKey}`}
    >
      <div className={`flex items-center gap-1 ${className.includes('text-right') ? 'justify-end' : ''} ${className.includes('text-center') ? 'justify-center' : ''}`}>
        {label}
        {isActive ? (
          sortConfig.direction === 'asc' ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />
        ) : (
          <ArrowUpDown className="h-3 w-3 opacity-30" />
        )}
      </div>
    </TableHead>
  );
};

export const useSort = (defaultKey = '', defaultDirection = 'desc') => {
  const [sortConfig, setSortConfig] = React.useState({ key: defaultKey, direction: defaultDirection });

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const sortItems = (items) => {
    if (!sortConfig.key) return items;
    return [...items].sort((a, b) => {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];
      // Numeric detection
      if (typeof aVal === 'number' || typeof bVal === 'number') {
        aVal = parseFloat(aVal) || 0;
        bVal = parseFloat(bVal) || 0;
      }
      // Date detection
      else if (aVal && bVal && !isNaN(Date.parse(aVal)) && !isNaN(Date.parse(bVal))) {
        aVal = new Date(aVal).getTime();
        bVal = new Date(bVal).getTime();
      }
      // String comparison
      else {
        aVal = String(aVal || '').toLowerCase();
        bVal = String(bVal || '').toLowerCase();
      }
      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  return { sortConfig, handleSort, sortItems };
};
